// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook } from '@atlassian/react-sweet-state';
import Store from '../../store.tsx';
import type { State } from '../../types.tsx';

type IsReadySelectorType = {
	isReady: boolean;
};

export const isReadySelector = ({ currentPage }: State): IsReadySelectorType => {
	const { apps } = currentPage;
	const appIds = Object.keys(apps);
	return {
		isReady: appIds.length ? appIds.every((id) => apps[id].endTime || apps[id].timeoutTime) : false,
	};
};

export const useSpaStatePageReady = createHook(Store, {
	selector: isReadySelector,
});
